const Red = {
    title: 'Red',
    background: 'radial-gradient(circle, #b36b6b 0%, #a33c3c 100%)',
    colors: {
        primary: '#a32a2a',
        secondary: '#b04c4c',
        terciary: '#915454',
        fourth: '#ffebec',
        fifth: '#fcf5f5'
    }
};

export default Red;